import { Button, Checkbox, Input } from "@mui/joy";
import React, { CSSProperties, useEffect } from "react";
import { BLACK, WHITE } from "../../../appConstants";

type Children = {
  id: string;
  label: string;
};

type MultiSelectProps = {
  children: Children[];
  selected: Set<string>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, id: string) => void;
};
const MultiSelectFilterComponent: React.FC<MultiSelectProps> = ({
  children,
  selected,
  onChange,
}) => {
  const inputRef = React.useRef<HTMLButtonElement>(null);
  const dropdownRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e.target as Node) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="w-full">
      <Button
        color="neutral"
        sx={{
          height: 32,
          // width: 106,
          backgroundColor: "#FFF",
          color: "#1C1C1E",
          ":hover": {
            backgroundColor: "#FFF",
          },
          paddingX: "12px",
          paddingY: 0,
          gap: "8px",
          borderRadius: "4px",
          border: `1px solid #EAEAED`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
        ref={inputRef}
        onClick={() => setOpen(!open)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.27396 14.1667C9.09688 14.1667 8.94847 14.1067 8.82875 13.9869C8.70889 13.867 8.64896 13.7185 8.64896 13.5415C8.64896 13.3642 8.70889 13.2158 8.82875 13.0963C8.94847 12.9765 9.09688 12.9167 9.27396 12.9167H10.8846C11.0617 12.9167 11.2101 12.9766 11.33 13.0965C11.4497 13.2163 11.5096 13.3648 11.5096 13.5419C11.5096 13.7191 11.4497 13.8675 11.33 13.9871C11.2101 14.1068 11.0617 14.1667 10.8846 14.1667H9.27396ZM6.04479 10.2083C5.86771 10.2083 5.71931 10.1484 5.59958 10.0285C5.47986 9.90868 5.42 9.76021 5.42 9.58313C5.42 9.4059 5.47986 9.2575 5.59958 9.13792C5.71931 9.01819 5.86771 8.95833 6.04479 8.95833H14.1138C14.2908 8.95833 14.4393 9.01826 14.5592 9.13813C14.6789 9.25799 14.7388 9.40646 14.7388 9.58354C14.7388 9.76076 14.6789 9.90917 14.5592 10.0288C14.4393 10.1485 14.2908 10.2083 14.1138 10.2083H6.04479ZM3.625 6.25C3.44792 6.25 3.29951 6.19007 3.17979 6.07021C3.05993 5.95035 3 5.80187 3 5.62479C3 5.44757 3.05993 5.29917 3.17979 5.17958C3.29951 5.05986 3.44792 5 3.625 5H16.5417C16.7188 5 16.8672 5.05993 16.9869 5.17979C17.1067 5.29965 17.1667 5.44813 17.1667 5.62521C17.1667 5.80243 17.1067 5.95083 16.9869 6.07042C16.8672 6.19014 16.7188 6.25 16.5417 6.25H3.625Z"
            fill="#1C1C1E"
          />
        </svg>
        <div
          style={{
            fontSize: "12px",
            fontWeight: "600",
            textAlign: "center",
            lineHeight: "18px",
            color: "#1C1C1E",
          }}
        >
          Filter By
        </div>
      </Button>
      {open && (
        <div
          ref={dropdownRef}
          className=""
          style={{
            width: "200px",
            position: "absolute",
            backgroundColor: WHITE.W_100,
            zIndex: 999,
            paddingTop:8,
            paddingBottom:8,
            boxShadow: "0px 4px 10px 4px rgba(130, 130, 130, 0.10)",
            marginTop: "4px",
            borderRadius: 8,
            height: 224,
            overflow: "scroll",
            scrollbarWidth: "none",
          }}
        >
          {children?.map((child) => {
            return (
              <div
                key={child?.id}
                className="flex items-center self-stretch px-4 py-4"
                style={{ height: 52 }}
              >
                <Checkbox
                  size="sm"
                  onChange={(e) => onChange(e, child?.id)}
                  checked={selected?.has(child?.id)}
                  // color={checkboxcolor ? "primary" : "neutral"}
                />
                <span
                  className="ml-2"
                  style={{
                        fontFamily:"Inter",
                          fontSize: 12,
                          fontStyle:"normal",
                          fontWeight: selected.has(child?.id) ? 600 :400,
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                >
                  {child?.label}
                </span>
              </div>
            );
          })}
          {/* <div style={{ height: 8 }}></div> */}
        </div>
      )}
    </div>
  );
};

export default MultiSelectFilterComponent;